export const defaulSetDateFilter = {
  // From first of last month
  startDate: new Date(new Date(new Date().setDate(1)).setMonth(new Date().getMonth() - 1)),

  // To today
  endDate: new Date(),

  // Disallow future dates
  maxDate: new Date(),

  timePicker: false,
};
